import { ReactElement } from "react";

import "./index.scss";

const year = new Date().getFullYear();
const Footer = (
    props: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
    >,
): ReactElement => {
    return (
        <footer className={"footer mt-widest"} {...props}>
            Copyright © {year} JET Charge.
        </footer>
    );
};

export default Footer;
